/** Chaves de algoritmos descontinuados — não aparecem na configuração de câmeras. */
export const DEPRECATED_ALGORITHM_KEYS = new Set([
  'alpr_infraction',
  'cellphone_infraction',
  'seatbelt',
  'helmet_detection',
]);

/** Nomes legados (fallback quando a API não envia `key`). */
const DEPRECATED_ALGORITHM_NAMES = new Set([
  'detecção de cinto de segurança',
  'detecção de capacete',
  'infração alpr',
  'alpr infraction',
  'cellphone infraction',
  'detecção de celular',
  'uso de celular',
]);

const normalizeKey = (value = '') => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const resolveAlgorithmKey = (algorithm = {}) => {
  if (algorithm.key) return normalizeKey(algorithm.key);
  if (algorithm.algorithm_key) return normalizeKey(algorithm.algorithm_key);
  const name = normalizeKey(algorithm.name || algorithm.algorithm_name || '');
  if (!name) return '';
  if (name === 'lpr' || name.includes('reconhecimento_de_placas') || name.includes('plate_recognition')) return 'lpr';
  if (name === 'vehicle_infraction' || name.includes('reconhecimento_de_infracoes') || name.includes('infracoes_ia')) return 'vehicle_infraction';
  if (name === 'bus_lane' || name.includes('faixa_de_onibus') || name.includes('monitoramento_de_faixa')) return 'bus_lane';
  if (name === 'alpr_infraction') return 'alpr_infraction';
  if (name.includes('face') || name.includes('facial')) return 'face_recognition';
  if (name.includes('seatbelt') || name.includes('cinto')) return 'seatbelt';
  if (name.includes('helmet') || name.includes('capacete')) return 'helmet_detection';
  if (name.includes('phone') || name.includes('celular')) return 'cellphone_infraction';
  return name;
};

export const isDeprecatedAlgorithm = (algorithm = {}) => {
  const key = resolveAlgorithmKey(algorithm);
  if (key && DEPRECATED_ALGORITHM_KEYS.has(key)) return true;
  const name = String(algorithm?.name || '').toLowerCase();
  if (DEPRECATED_ALGORITHM_NAMES.has(name)) return true;
  if (name.includes('alpr') && name.includes('infra')) return true;
  return false;
};

export const filterAllowedAlgorithms = (algorithms = []) => {
  if (!Array.isArray(algorithms)) return [];
  return algorithms.filter((algo) => !isDeprecatedAlgorithm(algo));
};

/** Rótulos amigáveis na UI de câmeras (mantém identidade do sistema). */
export const getAlgorithmDisplayLabel = (algorithm = {}) => {
  const key = resolveAlgorithmKey(algorithm);
  if (key === 'lpr') return 'Leitura de placas/passagens';
  if (key === 'face_recognition') return 'Reconhecimento Facial';
  if (key === 'vehicle_infraction') return 'Reconhecimento de Infrações (IA)';
  if (key === 'bus_lane') return 'Monitoramento de Faixa';
  return algorithm?.name || algorithm?.algorithm_name || 'Algoritmo não encontrado';
};

export const DEFAULT_FACE_SERVICE_CONFIG = {
  match_threshold: 0.40,
  min_face_confidence: 0.60,
};
